import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import WebinarsSection from '@/components/pages/webinars/components/WebinarsSection';
import { IComponent } from '@/types/_app';
import { Webinar } from '@/types/ArticleType';
import PageHeader from '@/components/display/headers/PageHeader';
import Breadcrumb from '@/components/display/headers/Breadcrumb';
import WebinarsSectionHeader from './components/WebinarsSectionHeader';

export interface PodcastPageControllerProps {
    webinars: Webinar[];
}

export const WebinarsPageController: IComponent<any> = ({ webinars }: PodcastPageControllerProps) => {
    const now = Math.floor(Date.now() / 1000);

    const upcoming = webinars
        .filter(w => w.customFields.date > now)
        .sort((a, b) => (a.customFields?.date ?? 0) - (b.customFields?.date ?? 0));

    const pastWebinars = webinars.filter(w => w.customFields.date <= now);

    return (
        <div className="w-full p-10">
            <Breadcrumb
                items={[
                    {
                        title: 'Webinars',
                        link: '/webinars',
                    },
                ]}
            />
            <PageHeader
                title="Blockworks Webinars"
                description="Blockworks Webinars help fund managers, traders, market makers, and institutions explore institutionally focused topics in digital assets."
            />
            {upcoming.length > 0 && (
                <>
                    <WebinarsSectionHeader title="Upcoming" />
                    <WebinarsSection webinars={upcoming} category="upcoming" />
                </>
            )}

            {pastWebinars.length > 0 && (
                <>
                    <WebinarsSectionHeader
                        title="On Demand"
                        description="Discover Blockworks archive of past webinars on demand. "
                    />
                    <WebinarsSection webinars={pastWebinars} category="ondemand" />
                </>
            )}
        </div>
    );
};

export default withExceptionCatcher(WebinarsPageController);
